<template>
  <div class="privacy-container">
    <div class="privacy-content">
      <header class="privacy-header">
        <h1>隐私政策</h1>
        <p class="last-updated">最后更新时间：2025年7月</p>
      </header>

      <div class="privacy-body">
        <section class="privacy-section">
          <h2>1. 概述</h2>
          <p>我们（以下简称"我们"、"本公司"）高度重视您的隐私保护。本隐私政策说明了我们如何收集、使用、存储和保护您的个人信息。使用我们的TikTok API集成应用（以下简称"本应用"）即表示您同意本隐私政策的条款。</p>
        </section>

        <section class="privacy-section">
          <h2>2. 信息收集</h2>
          <h3>2.1 我们收集的信息类型</h3>
          
          <h4>2.1.1 个人身份信息</h4>
          <ul>
            <li>姓名和用户名</li>
            <li>电子邮箱地址</li>
            <li>电话号码（可选）</li>
            <li>头像和个人资料信息</li>
          </ul>

          <h4>2.1.2 TikTok账户信息</h4>
          <ul>
            <li>TikTok账户连接信息（通过OAuth 2.0授权）</li>
            <li>TikTok用户ID和公开信息</li>
            <li>授权访问的TikTok数据范围</li>
            <li>授权令牌（加密存储）</li>
          </ul>

          <h4>2.1.3 使用数据</h4>
          <ul>
            <li>应用使用情况和功能交互</li>
            <!-- <li>设备信息（设备类型、操作系统、唯一设备标识符）</li>
            <li>IP地址和位置信息</li>
            <li>浏览记录和点击数据</li> -->
            <li>API调用记录和错误日志</li>
          </ul>

          <h4>2.1.4 内容数据</h4>
          <ul>
            <li>您创建、上传或分享的内容</li>
            <li>通过TikTok API获取的视频和图片元数据</li>
            <li>评论、点赞和互动记录</li>
            <li>媒体文件的处理状态</li>
          </ul>

          <h3>2.2 信息收集方式</h3>
          
          <h4>2.2.1 直接收集</h4>
          <ul>
            <li>注册账户时提供的信息</li>
            <li>TikTok OAuth授权时获取的信息</li>
            <li>个人资料更新</li>
            <!-- <li>客服咨询时提供的信息</li> -->
          </ul>

          <h4>2.2.2 自动收集</h4>
          <ul>
            <li>通过Cookies和类似技术</li>
            <li>应用分析工具</li>
            <li>日志文件记录</li>
            <li>TikTok API自动同步</li>
          </ul>

          <h4>2.2.3 第三方来源</h4>
          <ul>
            <li>TikTok平台API获取的公开信息</li>
            <li>TikTok授权范围内的用户数据</li>
            <li>合作伙伴提供的数据</li>
          </ul>
        </section>

        <section class="privacy-section">
          <h2>3. 信息使用</h2>
          <h3>3.1 使用目的</h3>
          <p>我们使用收集的信息用于：</p>

          <h4>3.1.1 服务提供</h4>
          <ul>
            <li>创建和管理您的账户</li>
            <li>提供TikTok API集成功能</li>
            <li>处理您的请求和交易</li>
            <li>发送服务相关通知</li>
            <li>同步TikTok数据</li>
          </ul>

          <h4>3.1.2 个性化体验</h4>
          <ul>
            <li>自定义内容推荐</li>
            <li>优化用户界面</li>
            <li>提供个性化设置</li>
            <li>基于TikTok数据的个性化服务</li>
          </ul>

          <h4>3.1.3 分析和改进</h4>
          <ul>
            <li>分析使用模式和趋势</li>
            <li>改进应用功能和性能</li>
            <li>开发新功能和服务</li>
            <li>优化API调用效率</li>
          </ul>

          <h4>3.1.4 安全和合规</h4>
          <ul>
            <li>防止欺诈和滥用</li>
            <li>确保平台安全</li>
            <li>遵守法律法规要求</li>
            <li>保护TikTok API安全</li>
          </ul>

          <h3>3.2 数据处理的法律依据</h3>
          <ul>
            <li>履行与您的合同义务</li>
            <li>合法权益（改进服务、安全防护）</li>
            <li>您的明确同意（TikTok授权）</li>
            <li>法律合规要求</li>
          </ul>
        </section>

        <section class="privacy-section">
          <h2>4. 信息共享</h2>
          <h3>4.1 我们不会出售您的个人信息</h3>
          <p>我们承诺不会向第三方出售、租赁或交易您的个人信息。</p>

          <h3>4.2 信息共享情况</h3>
          <p>我们可能在以下情况下共享信息：</p>

          <h4>4.2.1 服务提供商</h4>
          <ul>
            <li>云存储服务提供商</li>
            <li>分析服务提供商</li>
            <li>客服支持服务商</li>
            <li>支付处理服务商</li>
            <li>TikTok平台（通过API调用）</li>
          </ul>

          <h4>4.2.2 法律要求</h4>
          <ul>
            <li>遵守法律法规</li>
            <li>响应法律程序</li>
            <li>保护权利和安全</li>
            <li>防止违法行为</li>
          </ul>

          <h4>4.2.3 业务转让</h4>
          <ul>
            <li>公司合并、收购或资产出售时</li>
            <li>事先通知并获得您的同意</li>
          </ul>

          <h3>4.3 TikTok平台集成</h3>
          <ul>
            <li>通过TikTok API获取和同步数据</li>
            <li>遵循TikTok平台的隐私政策</li>
            <li>仅访问您授权的信息</li>
            <li>不向TikTok平台提供您的个人信息</li>
          </ul>
        </section>

        <section class="privacy-section">
          <h2>5. 数据存储与安全</h2>
          <h3>5.1 数据存储</h3>
          
          <h4>5.1.1 存储位置</h4>
          <ul>
            <li>数据主要存储在安全的云服务器上</li>
            <li>可能在不同地理位置备份</li>
            <li>遵循数据本地化要求</li>
            <li>TikTok授权令牌加密存储</li>
          </ul>

          <h4>5.1.2 存储期限</h4>
          <ul>
            <li>账户有效期内持续存储</li>
            <li>账户删除后30天内删除个人数据</li>
            <li>法律要求的情况下可能延长保存期</li>
            <li>TikTok授权撤销后立即删除相关数据</li>
          </ul>

          <h3>5.2 安全措施</h3>
          
          <h4>5.2.1 技术安全</h4>
          <ul>
            <li>数据传输加密（TLS/SSL）</li>
            <li>数据存储加密</li>
            <li>访问控制和身份验证</li>
            <li>定期安全审计</li>
            <li>API密钥和令牌安全保护</li>
          </ul>

          <h4>5.2.2 管理安全</h4>
          <ul>
            <li>员工隐私培训</li>
            <li>最小权限原则</li>
            <li>安全事件响应流程</li>
            <li>第三方安全评估</li>
          </ul>
        </section>

        <section class="privacy-section">
          <h2>6. 您的权利</h2>
          <h3>6.1 访问权</h3>
          <ul>
            <li>查看我们持有的您的个人信息</li>
            <li>获取数据处理活动的信息</li>
            <li>查看TikTok授权状态</li>
          </ul>

          <h3>6.2 更正权</h3>
          <ul>
            <li>更新不准确的信息</li>
            <li>完善不完整的信息</li>
          </ul>

          <h3>6.3 删除权</h3>
          <ul>
            <li>请求删除您的个人信息</li>
            <li>注销账户和数据</li>
            <li>撤销TikTok授权</li>
          </ul>

          <h3>6.4 限制处理权</h3>
          <ul>
            <li>限制某些数据处理活动</li>
            <li>反对基于合法权益的处理</li>
          </ul>

          <h3>6.5 数据可携带权</h3>
          <ul>
            <li>以结构化格式获取数据</li>
            <li>将数据传输至其他服务</li>
          </ul>

          <h3>6.6 撤回同意权</h3>
          <ul>
            <li>随时撤回之前给予的同意</li>
            <li>不影响撤回前的合法处理</li>
            <li>撤销TikTok授权</li>
          </ul>
        </section>

        <section class="privacy-section">
          <h2>7. Cookie和追踪技术</h2>
          <h3>7.1 Cookie使用</h3>
          <ul>
            <li>必要Cookie：确保基本功能</li>
            <li>分析Cookie：了解使用情况</li>
            <li>偏好Cookie：记住设置</li>
            <li>会话Cookie：维护登录状态</li>
          </ul>

          <h3>7.2 管理选择</h3>
          <ul>
            <li>浏览器Cookie设置</li>
            <li>应用内隐私选项</li>
            <li>退出分析追踪</li>
          </ul>
        </section>

        <section class="privacy-section">
          <h2>8. 儿童隐私</h2>
          <h3>8.1 年龄限制</h3>
          <ul>
            <li>本应用面向13岁以上用户</li>
            <li>不故意收集13岁以下儿童信息</li>
            <li>发现未成年用户将删除相关数据</li>
            <li>遵循TikTok平台的年龄限制政策</li>
          </ul>

          <h3>8.2 家长监护</h3>
          <ul>
            <li>鼓励家长监督孩子的网络活动</li>
            <li>提供家长联系和申诉渠道</li>
          </ul>
        </section>

        <section class="privacy-section">
          <h2>9. 国际数据传输</h2>
          <h3>9.1 跨境传输</h3>
          <ul>
            <li>数据可能传输至其他国家/地区</li>
            <li>确保适当的保护措施</li>
            <li>遵循相关法律要求</li>
            <li>TikTok数据可能存储在国外服务器</li>
          </ul>

          <h3>9.2 保护措施</h3>
          <ul>
            <li>标准合同条款</li>
            <li>充分性决定</li>
            <li>其他合法传输机制</li>
          </ul>
        </section>

        <section class="privacy-section">
          <h2>10. 隐私政策更新</h2>
          <h3>10.1 更新通知</h3>
          <ul>
            <li>重大变更会提前通知</li>
            <li>通过应用内通知或邮件告知</li>
            <li>更新版本在网站发布</li>
          </ul>

          <h3>10.2 持续使用</h3>
          <ul>
            <li>继续使用服务表示接受更新</li>
            <li>不同意可选择停止使用</li>
          </ul>
        </section>

        <section class="privacy-section">
          <h2>11. 联系我们</h2>
          <h3>11.1 隐私问题咨询</h3>
          <p>如果您对本隐私政策或数据处理有疑问，请联系我们：</p>
          <ul>
            <li><strong>邮箱：</strong> beiniu@beiniu.org</li>
            <li><strong>地址：</strong> 浙江省杭州市钱塘区下沙街道元创公园3幢709室</li>
            <!-- <li><strong>电话：</strong> 188-6880-8868</li> -->
            <!-- <li><strong>数据保护官：</strong> dpo@beiniu.vip</li> -->
          </ul>

          <h3>11.2 投诉渠道</h3>
          <ul>
            <li>优先通过上述方式联系我们</li>
            <li>可向相关监管机构投诉</li>
            <li>寻求法律救济</li>
          </ul>
        </section>
      </div>

      <footer class="privacy-footer">
        <router-link to="/" class="btn-back">返回首页</router-link>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  mounted() {
    document.title = '隐私政策 - TikTok集成应用'
  }
}
</script>

<style scoped>
.privacy-container {
  min-height: 100vh;
  background: #f8f9fa;
  padding: 2rem 1rem;
}

.privacy-content {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.privacy-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 3rem 2rem;
  text-align: center;
}

.privacy-header h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.last-updated {
  opacity: 0.9;
  font-size: 0.9rem;
}

.privacy-body {
  padding: 2rem;
}

.privacy-section {
  margin-bottom: 2rem;
}

.privacy-section h2 {
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #667eea;
}

.privacy-section h3 {
  color: #555;
  font-size: 1.2rem;
  margin: 1.5rem 0 0.5rem 0;
}

.privacy-section h4 {
  color: #666;
  font-size: 1rem;
  margin: 1rem 0 0.5rem 0;
  font-weight: 600;
}

.privacy-section p {
  line-height: 1.6;
  color: #666;
  margin-bottom: 1rem;
}

.privacy-section ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.privacy-section li {
  line-height: 1.6;
  color: #666;
  margin-bottom: 0.5rem;
}

.privacy-footer {
  padding: 2rem;
  text-align: center;
  border-top: 1px solid #eee;
}

.btn-back {
  display: inline-block;
  padding: 0.75rem 2rem;
  background: #667eea;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 500;
  transition: background-color 0.3s;
}

.btn-back:hover {
  background: #5a6fd8;
}

@media (max-width: 768px) {
  .privacy-container {
    padding: 1rem 0.5rem;
  }
  
  .privacy-header {
    padding: 2rem 1rem;
  }
  
  .privacy-header h1 {
    font-size: 2rem;
  }
  
  .privacy-body {
    padding: 1.5rem;
  }
}
</style> 